import { render } from "./PageProductGroupView.vue?vue&type=template&id=f17c738e&scoped=true"
import script from "./PageProductGroupView.vue?vue&type=script&lang=js"
export * from "./PageProductGroupView.vue?vue&type=script&lang=js"

import "./PageProductGroupView.vue?vue&type=style&index=0&id=f17c738e&scoped=true&lang=css"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f17c738e"]])

export default __exports__